import React from 'react';
import {
    ContainerBox,
    BackBtn,
    BackIcon,
    ButtonContainerBox,
    Title,
    ImageContainerBox,
    TitleContainerBox,
    CustomTooltip,
    ButtonAddToClassContainerBox,
    SuccessIcon,
    AddToClassBtn,
    MainTitleContainerBox,
    AddClassIcon,
    ErrorsIcon,
    ScrollImages,
    RegenerateBtn, DropBoxBox
} from '../Style/RandomSamplerClasses.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {ImageListItem, Box, CircularProgress, ThemeProvider, RefreshIcon} from '../../../ui-library';
import {ImageUrl} from '../../ImageUrl';
import useImageModalView from '../../ImageModalView/Controller/useImageModalView.controller';
import ImageModalView from '../../ImageModalView/View/ImageModalView.view';
import useRandomSamplerClasses from '../Controllers/useRandomSamplerClasses.controller';
import utilService from '../../../services/utilService';
import {InputType} from '../../../pages/CreateAutoProject/Config/CreateAutoProject.constants';
import {ModalBox} from '../../CreateSharedClassModal/Style/CreateSharedClassModal.style';
import {RandomImagesAddClass} from '../../ReferenceImageUpload';
import {IProps} from '../Config/RandomSamplerClasses.types';
import {DATA_SOURCES, DATA_TIME, MAX_LEN_CLASS_NAME} from '../Config/RandomSamplerClasses.constants';
import {RandomSamplerDropDownView as RandomSamplerDropDown} from '../../RandomSamplerDropDown';
import { FLOW } from '../../../pages/RandomSampler/Config/RandomSampler.constants';

const RandomSamplerClasses = ({classes, goBackToObjectsTab, randomSamplerState, setState, getRandomSamplerData, addImageToClassReference}:IProps) => {
    const {
        open,
        setOpen,
        activeHover,
        setActiveHover,
        setCurrentImageIndex,
        currentImageIndex} = useImageModalView();
    const imageArray = JSON.parse(JSON.stringify(classes)).map((obj) => obj.img);
    const {pressOnAddImagesBtn, addClass, hasDropdownChanged, handleDropdownChange, setHasDropdownChanged} = useRandomSamplerClasses(setState, randomSamplerState, addImageToClassReference);

    const isDisabled = !randomSamplerState.manualImages.some((mImages) => mImages.approved);
    const isRegenerateBtnEnabled = randomSamplerState.isRandomBtn || hasDropdownChanged;


    return (
        <ContainerBox>
            <ImageModalView
                imageList={imageArray}
                setOpen={setOpen}
                open={open}
                currentImageIndex={currentImageIndex}
            />
            <ButtonContainerBox>
                <BackBtn onClick={() => goBackToObjectsTab()} startIcon={<BackIcon/>} size='small'>{_SYSTEM_TITLES.backRandom}</BackBtn>
                <RegenerateBtn disabled={!isRegenerateBtnEnabled}
                    onClick={() => {
                        if (isRegenerateBtnEnabled) {
                            getRandomSamplerData(randomSamplerState.dataSource, randomSamplerState.dataTime);
                            setHasDropdownChanged(false);
                        }
                    }}
                    startIcon={<RefreshIcon/>} size='small'>{_SYSTEM_TITLES.regenerateTitle}</RegenerateBtn>
            </ButtonContainerBox>
            <DropBoxBox>
                <RandomSamplerDropDown
                    title={_SYSTEM_TITLES.dataSourceTitleCheckBox}
                    checkBoxValue={randomSamplerState.dataSource}
                    label={_SYSTEM_TITLES.dataSourceSelectInput}
                    options={DATA_SOURCES}
                    checkIfDisable={(key) => !randomSamplerState.availableSources.includes(key)}
                    changeOption={(value) => handleDropdownChange('dataSource', value)}/>
                <RandomSamplerDropDown
                    title={_SYSTEM_TITLES.dataTimeTitleCheckBox}
                    checkBoxValue={randomSamplerState.dataTime}
                    label={_SYSTEM_TITLES.dataSourceSelectInput}
                    options={DATA_TIME}
                    checkIfDisable={() => false}
                    changeOption={(value) => handleDropdownChange('dataTime', value)}/>
            </DropBoxBox>
            <ThemeProvider>
                <ModalBox onClose={() => setState({isAddClass: false, globalClassError: ''})} open={randomSamplerState.isAddClass}>
                    <>
                        <RandomImagesAddClass
                            getError={(error) => setState({addClassError: error})}
                            globalError={randomSamplerState.globalClassError}
                            getValue={(value) => setState({newClassInput: value, globalClassError: ''})}
                            inputType={InputType.ProjectName}
                            inputcolor='black'
                            addClass={addClass}
                            isShowBtn={true}
                            inputLabel={_SYSTEM_TITLES.addClassInput} />
                    </>
                </ModalBox>
            </ThemeProvider>
            <MainTitleContainerBox>
                <Title>{_SYSTEM_TITLES.availableClassesTitle}</Title>
                <CustomTooltip title={_SYSTEM_TITLES.addNewClassToolTip} placement='top' arrow>
                    <AddClassIcon onClick={() => !randomSamplerState.globalLoading && setState({isAddClass: true, globalClassError: ''})}/>
                </CustomTooltip>
            </MainTitleContainerBox>
            <ScrollImages>
                {classes.map((class_obj, i) => (
                    <ImageContainerBox key={i}>
                        <ImageListItem key={i}>
                            <ImageUrl
                                img={class_obj.img}
                                isAspectRatio={true}
                                onMouseOver={() => setActiveHover(i)}
                                onMouseLeave={() => setActiveHover(-1)}
                                isHover={activeHover === i}
                                setOpen={setOpen}
                                setCurrentImageIndex={setCurrentImageIndex}
                                imageIndex={i}
                                fromreferenceinmr={true}
                                isMoveMode={false}
                                flow={FLOW.randomImages}/>
                        </ImageListItem>
                        <TitleContainerBox>
                            <CustomTooltip title={class_obj.name} placement='top' arrow>
                                <Box>
                                    <Title>{utilService.normalizedSting(class_obj.name, MAX_LEN_CLASS_NAME)}</Title>
                                </Box>
                            </CustomTooltip>
                            <ButtonAddToClassContainerBox>
                                {(class_obj.isShowAddToClassSuccess || class_obj.isShowAddToClassError)
                                    ? <>
                                        {class_obj.isShowAddToClassSuccess && <SuccessIcon color='success' />}
                                        {class_obj.isShowAddToClassError && <ErrorsIcon color='error' />}
                                    </>
                                    : <AddToClassBtn
                                        disabled={!((classes.every((classObj) => classObj.isChosen === false) || class_obj.isChosen) && !isDisabled)}
                                        onClick={() => !randomSamplerState.globalLoading && pressOnAddImagesBtn(i)} size='large' >
                                        {class_obj.isChosen ? <CircularProgress size='16px' color='inherit'/> : 'Add'}
                                    </AddToClassBtn>}
                            </ButtonAddToClassContainerBox>
                        </TitleContainerBox>
                    </ImageContainerBox>
                ))}
            </ScrollImages>
        </ContainerBox>
    );
};


export default RandomSamplerClasses;
